var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "c-section-nav" },
    [
      _vm.selectedSection !== "all"
        ? _c(
            "button",
            {
              staticClass: "c-btn c-btn--primary c-btn--has-icon",
              attrs: { type: "button", "aria-label": "Tilbake til oversikt" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.close()
                },
              },
            },
            [
              _c("icon-left", {
                staticClass:
                  "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
              }),
              _vm._v("\n    Oversikt\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSectionName === true
        ? _c(
            "transition",
            { attrs: { name: "section-nav-fade", mode: "out-in" } },
            [
              _c(
                "p",
                {
                  staticClass:
                    "c-section-nav__header c-section-nav__header--big",
                },
                [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]
              ),
            ]
          )
        : _c(
            "transition",
            { attrs: { name: "section-nav-fade", mode: "out-in" } },
            [
              _c("select-section", {
                staticClass:
                  "c-select c-select--center c-select--big c-section-nav__header c-section-nav__header--big",
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }